<script setup lang="ts">
/** The catalogue cover — a row column (`cover_path`), not part of the document. Remove sets it to
 *  `null`; the object stays in the bucket (a duplicate may share it). */
import { AppText } from '@shared/ui/typography'

import { useAssignmentCoverUploader } from '../../../model/assignments/assignment-cover-uploader.hook'
import AssignmentImageUploader from './AssignmentImageUploader.vue'

defineOptions({
  name: 'AssignmentCoverUploader',
})

const {
  refCoverPath,
  refHint,
  setCover,
} = useAssignmentCoverUploader()
</script>

<template>
  <div class="assignment-cover-uploader">
    <!-- The uploader owns the file, the preview and the signed link; this component owns the fact
         that the value it emits is a ROW COLUMN rather than a document field. -->
    <AssignmentImageUploader
      label="Image"
      alt="Assignment cover image"
      cover
      cannot-upload-hint="Save the assignment before uploading an image."
      :value="refCoverPath"
      @update:value="setCover"
    />

    <AppText
      name="body2"
      color="slate-500"
    >
      {{ refHint }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./AssignmentCoverUploader.scss" />
